import { useLocation, useNavigate } from "react-router-dom";
import { clearSession, getSession } from "../../../utils/session";
import { post, get } from "../../../api";
import { EMPLOYR_LOGIN_SESSION } from "../../../constant/session";
import { useState, useRef, useEffect } from "react";

const AdminSideBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [companyListOpen, setCompanyListOpen] = useState(false);
  const companyListRef = useRef(null);
  const [listHeight, setListHeight] = useState(0);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dataFetched, setDataFetched] = useState(false);

  // Remove the useEffect that fetches companies on component mount

  useEffect(() => {
    if (companyListRef.current) {
      const height = companyListRef.current.scrollHeight;
      setListHeight(height);
    }
  }, [companyListOpen, companies.length]);

  const fetchCompanies = async () => {
    if (dataFetched) return; // Don't fetch if data is already fetched
    
    setLoading(true);
    try {
      const response = await get("user/company/subscription?type=Review");
      console.log("Companies API response:", response);
      
      // Check if response has data property or is directly the array
      const companiesData = response.data || response;
      
      if (companiesData && Array.isArray(companiesData)) {
        console.log("Companies data to use:", companiesData);
        setCompanies(companiesData);
        setDataFetched(true);
      } else {
        console.error("Response format unexpected:", response);
        setError("Invalid data format received");
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
      setError("Failed to load companies");
    } finally {
      setLoading(false);
    }
  };

  const toggleCompanyList = (e) => {
    e.preventDefault();
    setCompanyListOpen(!companyListOpen);
    
    // Fetch companies when opening the dropdown if not already fetched
    if (!companyListOpen && !dataFetched) {
      fetchCompanies();
    }
  };

  const logout = async (e) => {
    e?.preventDefault();
    try {
      const url = "user/users/logout";
      const response = await post(url, {});
      if (response?.status === 200) {
        clearSession(EMPLOYR_LOGIN_SESSION);
        navigate("/login");
      }
    } catch (e) {
      if (e?.response?.data?.status === 498) {
        clearSession(EMPLOYR_LOGIN_SESSION);
        navigate("/login");
      }
    }
  };

  const isActiveNav = (nav) => {
    return location.pathname.indexOf(nav) !== -1 ? "active" : "";
  };

  // Remove this duplicate function
  // const toggleCompanyList = (e) => {
  //   e.preventDefault();
  //   setCompanyListOpen(!companyListOpen);
  // };

  return (
    <>
      <div className="user-sidebar">
        <div className="sidebar-inner">
          <ul className="navigation">
            <li className={isActiveNav("dashboard")}>
              <a href="/#/dashboard">
                {" "}
                <i className="la la-home"></i> Dashboard
              </a>
            </li>
            <li className={isActiveNav("profile")}>
              <a href="/#/profile">
                <i className="la la-user-tie"></i>View Profile
              </a>
            </li>
            <li className={isActiveNav("reports")}>
              <a href="/#/reports">
                <i className="la la-chart-pie"></i>Reports
              </a>
            </li>
            <li className={isActiveNav("managesubscriptions")}>
              <a href="/#/managesubscriptions">
                <i className="la la-user-edit"></i> Manage Subscriptions
              </a>
            </li>
            
            {/* All Company dropdown */}
            <li className={`${isActiveNav("companies")} ${companyListOpen ? "active" : ""}`}>
              <a href="#" onClick={toggleCompanyList} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span><i className="la la-building"></i> All Company</span>
                <i className={`la ${companyListOpen ? "la-angle-down" : "la-angle-right"}`}></i>
              </a>
              
              {/* Company submenu with dynamic height calculation */}
              <div 
                style={{ 
                  overflow: "hidden",
                  transition: "max-height 0.3s ease-in-out",
                  maxHeight: companyListOpen ? `${listHeight}px` : "0",
                }}
              >
                <ul 
                  ref={companyListRef}
                  style={{
                    paddingLeft: "20px",
                    margin: 0,
                    listStyle: "none"
                  }}
                >
                  {loading ? (
                    <li style={{ padding: "10px 0" }}>Loading companies...</li>
                  ) : error ? (
                    <li style={{ padding: "10px 0", color: "red" }}>{error}</li>
                  ) : companies && companies.length > 0 ? (
                    companies.map((company, index) => {
                      console.log(`Company ${index}:`, company);
                      return (
                        <li key={company.companyId || index} style={{ padding: "10px 0" }}>
                          <a 
                            href={`/#/applicants?companyId=${company.companyId}&companyName=${encodeURIComponent(company.companyName || "Unnamed Company")}`} 
                            style={{ 
                              display: "block",
                              color: "inherit",
                              textDecoration: "none"
                            }}
                          >
                            <i className="la la-building-o"></i> {company.companyName || "Unnamed Company"}
                          </a>
                        </li>
                      );
                    })
                  ) : (
                    <li style={{ padding: "10px 0" }}>No companies available</li>
                  )}
                </ul>
              </div>
            </li>
            
            <li className={isActiveNav("blogs")}>
              <a href="/#/blogs">
                <i className="la la-list"></i> Manage Blogs
              </a>
            </li>
            <li className={isActiveNav("postBlog")}>
              <a href="/#/postBlog">
                <i className="la la-edit"></i> Post New Blog
              </a>
            </li>
            <li className={isActiveNav("messages")}>
              <a href="/#/messages">
                <i className="la la-envelope"></i>Messages
              </a>
            </li>
            <li className={isActiveNav("feedback")}>
              <a href="/#/feedback">
                <i className="la la-sms"></i> Feedback
              </a>
            </li>
            <li className={isActiveNav("user-management")}>
              <a href="/#/user-management">
                <i className="la la-user-edit"></i> User Management
              </a>
            </li>
            <li>
              <a onClick={logout}>
                <i className="la la-sign-out"></i>Logout
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default AdminSideBar;